import {
  AccessToApp,
  ConfirmLoginMail,
  FilterOptions,
  IncompletePersonalData,
  LegalFooter,
  MDetailRoute,
  MSubheaderPlanner,
  PLoadingItinerary,
  PWithoutResults,
  UiModal,
  UiModalRight,
  UploadDocuments,
  UserLoginModal,
  AveTariff,
  RefreshTarifsModal,
  DeletePlanification,
  ConsentTermsRegisterModal,
  AgeConfirmation,
  UsersUnder16,
  IncidentsRoute,
  SilentCarRules,
  MPaginatorTrain,
  PstTariff,
  MSubheaderPlannerTrain,
} from "libs/raas-ui-react-components/src/components";
import { useEffect, useRef, useState } from "react";
import {
  getItemStorage,
  removeItemStorage,
  setItemStorage,
} from "services/util/sessionStorage.service";
import {
  calcCurrentPrice,
  calcCurrentPriceTotal,
  checkDeletedRoutes,
  checkIsWalk,
  checkMappedDeleteItems,
  filterTripsFromService,
  formatPrice,
  getContextPerPassenger,
  getContextPerPassengerByGroup,
  getProvider,
  getProviderType,
  getSeatTrainMapCallPromise,
  getTarifBono,
  getTarifs,
  getTotalPriceFromtravellerListByTarif,
  isEmptyArray,
  manageDeleteTransbordosMetros,
  mapResultTrip,
  mapTripQuery,
  mapTripToDetail,
  mapTripToSummary,
  setTarifs,
  setTarifsLiterals,
  travelServices,
  TripCall,
  TripDetail,
  tripWithMissingTarif,
  whatTransportIs,
  getReturnAveModalTarif,
  setReturnTrainSelectedList,
  checkIfReturnTrainIsSelected,
  mapReturnFromToAveDetail,
  calcEco,
  ETransportLiterals,
} from "./TripSelectorTrain.service";
import {
  getFooterLiterals,
  getNoResultLiterals,
  getTransportFilterLiterals,
  initialDetailLiterals,
  initialDetailLiteralsAtom,
  initialDriverCommentLiterals,
  initialTarifLiterals,
  initialTarifTikets,
  plannerSubLiterals,
  initialBabyChairsLiterals,
  initialuploadDocumentsLiterals,
  initialAccessToAppLiterals,
  initialAccessToAppMotoLiterals,
  LoginModalLiterals,
  ReactPathNavigation,
  ConfirmModalLiterals,
  PersonalDataModalLiterals,
  loadingReturnTripLiterals,
  getResumePath,
  checkEmptyObject,
  initialAveTariffLiterals,
  initialBasicSummary,
  getRouteBoxLiterals,
  initialRefreshModalLiterals,
  initialDeletePlanificationModalLiterals,
  getNoResultDateTripLiterals,
  checkISCurrentDate,
  checkDiffTimeFromCurrent,
  modifyBodyCurrentDate,
  getFilterTravelPreference,
  initialFromToAlertModalLiterals,
  initialFromToAlertReturnModalLiterals,
} from "./TripSelectorTrain.util";
import useToast from "hooks/useToast";
import "./TripSelectorTrain.scss";
import { useTranslation } from "react-i18next";
import {
  CHECKAGE,
  checkUnder16,
  emptyArray,
  mappingScreenNameAnalytics,
} from "services/util/util.service";
import useSession from "hooks/useSession";
import {
  getBodyLongMover,
  getDeviceKey,
  initbodyLongMover,
  initTypeTrip,
  IUserData,
  RaaSSession,
  SessionStorageItems,
  setBodyLongMover,
  setDataCodePromoSession,
  setFleetSessionName,
  setOffSite,
  setReturnTripSummaryDetail,
  setStorage,
  setTripSummaryDetail,
  setUserDetail,
} from "services/user/user.session.service";
import { useNavigate } from "react-router-dom";
import { postAxios } from "services/api/api.service";
import { apiNames } from "services/api/endpoint.service";
import { getUserData } from "services/user/user-micros.service";
import { openMail } from "pages/public/RegistroUser/RegisterUser.service";
import { IBodyTripSelected, ITripSelectedDetails } from "models/TripInterface";
import { isLoading } from "services/util/loader.service";
import {
  getRealDataFav,
  needImperativeData,
} from "services/util/addressesFav.service";
import { manageDeleteAveCercanias } from "./renfe.service";
import {
  filterByEcologic,
  filterByEconomic,
  filterByEconomicLongMover,
  filterBySpeed,
  filterByTime,
} from "services/util/trips.service";
import {
  IReturnTrainStateControlObject,
  PlanningObj,
  TripMaped,
} from "./TripSelectorTrain.model";
import {
  dataLayerAddToCart,
  dataLayerSelectItem,
  dataLayerViewItem,
  dataLayerViewItemList,
} from "services/util/dataLayerAnalytics";
import {
  invertBodyData,
  mapPlanningObject,
  _checkisPastDate,
} from "./functions/manageSubheader";
import { getPromiseByProvider } from "services/user/user-login-social.service";
import {
  apiUpdateUnder16Age,
  getUsersUnder16Literals,
} from "pages/public/Planner/PlannerFlow.service";
import { getSilentCarLiterals, pricesConverter } from "../AveFlow/AveFlow.util";
import { ItemType } from "../MyTrips/MyTrips.model";
import { getInformationStationsApi } from "pages/public/TrainPlanner/TrainFlowPlanner.service";
import { IStation } from "pages/public/TrainPlanner/TrainFlowPlanner.model";
import {
  canNotBuyTrip,
  checkCompleteTrainsWhenDeleting,
  getNoResultTrainArrivalLiterals,
} from "../TripSelector/TripSelector.util";
declare const window: any;
export default function TripSelector() {
  const { openToast } = useToast();
  const [t] = useTranslation("tripSelector");
  const [t2] = useTranslation("plannerFlow");
  const [t3] = useTranslation("aveFlow");
  const {
    userConnected,
    logged,
    loggedSocial,
    tripSelectedDetails,
    tripReturnSelectedDetails,
    setFleetKarhooName,
    setSession,
    setLogged,
    setUserConnected,
    setTripSelectedDetails,
    setReturnTripSelectedDetails,
    setTypeTrip,
  } = useSession(); // de aqui info user
  const navigate = useNavigate();
  const [planningObject, setPlanningObject] = useState({} as any); // de aqui comprobar las silitas
  const [selectedTrip, setSelectedTrip] = useState({} as any); // se utiliza para el body de creacion
  const [travellersList, setTravellersList] = useState([] as any);
  const [trips, setTrips] = useState([] as any);
  const [orderedTrips, setOrderedTrips] = useState([] as any);
  const [filteredTrips, setFilteredTrips] = useState([] as any);
  const filterOptions = `['${t("trips.filter.fast")}','${t(
    "trips.filter.econ"
  )}','${t("trips.filter.ecol")}']`;
  const [showFiltersModal, setShowFiltersModal] = useState(false);
  const [showSubHeader, setShowSubHeader] = useState(false);
  const [isReturnTrip, setIsReturnTrip] = useState(false);
  const [isTariffMissing, setIsTariffMissing] = useState(false); //
  const routeBoxLiterals = getRouteBoxLiterals(t);
  const literalsConfirmEmail = ConfirmModalLiterals(t);
  // initial render
  const [initialRender, setInitialRender] = useState(false);
  // no results
  const footerLiterals = getFooterLiterals(t);
  const noResultLiterals = getNoResultLiterals(t);
  const noResultDateTripLiterals = getNoResultDateTripLiterals(t);
  const [showNoResults, setShowNoResults] = useState(false);
  const [showNoResultsByDate, setShowNoResultsByDate] = useState(false);
  // filter states
  const [paginatorPage, setPaginatorPage] = useState(1);
  const [filtersOptions, setFiltersOptions] = useState(
    getTransportFilterLiterals(t)
  );
  const [numberOfFilters, setNumberOfFilters] = useState(6);
  const [filterTrip, setFilterTrip] = useState("2");
  // detail vars
  const [detailsSelector, setDetailSelector] = useState([] as any[]);
  const [tripSummaryData, setTripSummaryData] = useState(
    initialBasicSummary() as any
  );
  const detailLiteralsAtom = initialDetailLiteralsAtom(t); //
  const detailLiterals = initialDetailLiterals(t);

  const [detailIndexSelected, setDetailIndexSelected] = useState(0);
  const [idPstNotChangeable, setIdPstNotChangeable] = useState("");

  const [detailPrice, setDetailPrice] = useState(
    {} as { sum: number; desc: string }
  );
  const [detailPriceTotal, setDetailPriceTotal] = useState(
    {} as { sum: number; desc: string }
  );
  const [disableDetailButton, setDisableDetailButton] = useState(false);
  // modales
  const [showTariff, setShowTarif] = useState(false);
  const [tarifBono, setTarifBono] = useState(false);
  const [tarifAdress, setTarifAdress] = useState("");
  const [tariffLiterals, setTariffLiterals] = useState(initialTarifLiterals(t));
  const [tariffTickets, setTariffTickets] = useState(initialTarifTikets(t));
  const [tariffFilters, setTariffFilters] = useState([] as any[]);
  const [tariffTag, setTariffTag] = useState({
    text: "Karhoo",
    color: "",
    bordercolor: "",
    backgroundcolor: "#F11B77",
  });
  //ave
  const [avetariffLiterals, setAveTariffLiterals] = useState(
    initialAveTariffLiterals(t)
  );
  const silentCarLiterals = getSilentCarLiterals(t3);

  const [fromToAlertModalLiterals, setFromToAlertModalLiterals] = useState(
    initialFromToAlertModalLiterals(t)
  );
  const [fromToAlertReturnModalLiterals, setFromToAlertReturnModalLiterals] =
    useState(initialFromToAlertReturnModalLiterals(t));
  const [showAveTariff, setShowAveTariff] = useState(false);
  const [showSilentCardModal, setShowSilentCardModal] = useState(false);
  const [showFromToTrainList, setShowFromToTrainList] = useState(false);
  const [isTrainSelected, setIsTrainSelected] = useState(false);
  const [isTrainRequested, setIsTrainRequested] = useState(false);
  const [isTrainRequestedFromBuyButton, setIsTrainRequestedFromBuyButton] =
    useState(false);

  const [noteDriverComment, setNoteDriverComment] = useState(
    [] as Array<{ type: string; value: string; id: number }>
  );
  const [showDriverComment, setShowDriverComment] = useState(false);
  const [driverCommentLiterals, setDriverCommentLiterals] = useState(
    initialDriverCommentLiterals(t)
  );
  const [showBabyChair, setShowBabyChair] = useState(false);
  const [babyChairsLiterals, setbabyChairsLiterals] = useState(
    initialBabyChairsLiterals(t)
  );
  const [showUploadDocument, setShowUploadDocument] = useState(false);
  const [uploadDocumentLiterals] = useState(initialuploadDocumentsLiterals(t));
  const [showAccessToApp, setShowAccessToApp] = useState(false);
  const [accessToAppLiterals, setAccessToAppLiterals] = useState(
    initialAccessToAppLiterals(t)
  );
  const [refreshTarifModalLiterals] = useState(initialRefreshModalLiterals(t));
  const [threemodals, setThreeModals] = useState(false);
  const [twomodals, setTwoModals] = useState(false);
  const [mDetailRouteEvent, saveMDetailRouteEvent] = useState({} as any);
  const [showRefreshModal, setShowRefreshModal] = useState(false);

  const [indexDeleteItem, setIndexDeleteItem] = useState(null as number | null);
  const [showDeleteItemModal, setShowDeleteItemModal] = useState(
    false as boolean
  );
  const [showIncidentModal, setShowIncidentModal] = useState(false as boolean);
  const [
    deletePlanificationModalLiterals,
    setDeletePlanificationModalLiterals,
  ] = useState(initialDeletePlanificationModalLiterals(t));

  // Login modal
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [loginToken, setLoginToken] = useState();
  const [step, setStep] = useState(0);
  const [email, setEmail] = useState("");
  const [password, setPass] = useState("");
  const [indexSelectedRoute, setIndexSelectedRoute] = useState(0);
  const [selectionVehicleEvent, setselectionVehicleEvent] = useState({} as any);
  // Estados vuelta
  const aveSectionDefaultValue = {
    isAveSelected: false,
    aveTripList: [],
    payedPassengerNumber: 0,
    summarySection: { otherTransportPrice: 0, aveSummaryList: [] },
  };
  const [returnStep, setReturnStep] = useState(0); // 0 ida, 1 loading, 2 vuelta
  let [departureAveSection, setIsAveSelected] = useState(
    aveSectionDefaultValue
  );
  let [returnAveSection, setIsReturnAveSelected] = useState(
    aveSectionDefaultValue
  );

  const [indexSelectedObj, setIndexSelectedObject] = useState({ index: 0 });
  const [selectIndex, setSelectIndex] = useState({});
  const [bodyFilterTrips, setBodyFilterTrips] = useState({} as PlanningObj);
  const [plannerSubLiteralsData, setPlannerSubLiterals] = useState(
    plannerSubLiterals(t)
  );
  let lenguage = "";
  // lista de trenes en la modal de vuelta
  const [fromToTickets, setFromToTickets] = useState([] as any);
  const [trainModalTariffSelected, setTrainModalTariffSelected] = useState(
    [] as any
  );
  const [shpCtxReturnTrainSelectedArray, setShpCtxReturnTrainSelectedArray] =
    useState([] as IReturnTrainStateControlObject[]);
  const [shpCtxReturnIndexDeleteItem, setShpCtxReturnIndexDeleteItem] =
    useState(0);

  // control under16 age
  const [tGlobal] = useTranslation("global");
  const [confirmationAge, setConfirmationAge] = useState(false);
  const [isOver16, setIsOver16] = useState(false);
  const [showModalUnder16, setShowModalUnder16] = useState(false as boolean);
  const usersUnder16ModalLiterals = getUsersUnder16Literals(t);
  const [incidentsRoute, setIncidentsRoute] = useState(null);

  const [selectedRateSilentCar, setSelectedRateSilentCar] = useState(false);

  const [initialBody, setInitialBody] = useState("");
  const [calendarDays, setCalendarDays] = useState(null as any);

  const bodySearch = getBodyLongMover();
  const [bonoAveFree, setBonoAveFree] = useState(false);
  const noResultTrainArrival = getNoResultTrainArrivalLiterals(t);
  ///// -----> USE EFECTS ZONE

  //userEffect para las analiticas
  useEffect(() => {
    if (filteredTrips.length !== 0) {
      analyticsOfAllRoutes();
    }
  }, [filteredTrips]);

  useEffect(() => {
    /*let objetTrip=JSON.parse(sessionStorage.getItem('raas-trip-planning')as any)

let date= new Date(objetTrip.departureDate.value);

    const aux={
      ...bodySearch,
      month:((date.getMonth() + 1) < 10 ? '0' : '')+ (date.getMonth() + 1),
      year:date.getFullYear().toString()
    }

    setInitialBody(aux);
    setBodyLongMover(aux)*/
    //console.log("initialBody",initialBody)
    setInitialBody(bodySearch);
  }, []);

  const analyticsOfAllRoutes = () => {
    const passengersList = planningObject?.passengers?.value;
    let screenName = "";
    let typeTrip = "oneway";
    if (isReturnTrip === false) {
      screenName = "oneway";
    } else {
      typeTrip = "round";
      //ida
      if (returnStep === 0) {
        screenName = "departure";
        // vuelta
      } else if (returnStep === 1) {
        screenName = "arrival";
      }
    }
    window.dataLayer?.push({
      event: "page_view",
      screen_name: screenName,
      screen_class: "trip_result",
    });

    //Para el detalle
    window.dataLayer?.push({
      event: "page_view",
      screen_name: screenName,
      screen_class: "trip_detail",
    });
    //Analiticas de todas la rutas
    dataLayerViewItemList(
      passengersList,
      filteredTrips,
      detailsSelector,
      filterTrip,
      screenName,
      typeTrip
    );
    setOffSite(false);
    setDataCodePromoSession({
      voucherCode: "",
      voucherAmount: 0,
      discountType: "DOCO",
      isValid: false,
      reset: false,
      totalPrice: "0,00 €",
      totalPriceToPay: "0,00 €",
    });
    removeItemStorage(SessionStorageItems.RAAS_ANY_PAID);
    removeItemStorage(SessionStorageItems.RAAS_OFF_SITE);
    removeItemStorage(SessionStorageItems.RAAS_PAY_CIT);
    removeItemStorage(SessionStorageItems.RAAS_POLICY);
    removeItemStorage(SessionStorageItems.RAAS_CONFIRMED_TARIFS);
    removeItemStorage(SessionStorageItems.RAAS_ACCEPTED_POLITICAL);
  };

  useEffect(() => {
    if (sessionStorage?.getItem("current-page")) {
      getData();
      sessionStorage?.removeItem("current-page");
      return;
    }

    getInitialUserFilter();
    const returnJourney = !!tripReturnSelectedDetails
      ? tripReturnSelectedDetails
      : {};
    const currentStep = checkEmptyObject(returnJourney) ? 0 : 2;
    setReturnStep(currentStep);
    let body = {};
    if (false) {
      // TODO - si el parametro va por query
      // tripApiCall(body as PlanningObj);
    } else if (true) {
      // si viene por session storage
      body = getSessionQuery();
      if (body === null) {
        navigate("/planTrain");
      } else {
        const travellersList = _makeTravellersList(body as PlanningObj);
        setTravellersList(travellersList);

        const queryBody = body as PlanningObj;
        const departureDate = new Date(queryBody.departureDate.value);
        const { date, hours, minutes } = _checkisPastDate(
          departureDate,
          +queryBody.departureSchedule.value.hours,
          +queryBody.departureSchedule.value.minutes
        );
        const aux = {
          hours,
          minutes,
          searchForArrival: queryBody.departureSchedule.value.searchForArrival,
        };
        queryBody.departureSchedule.value = aux as any;
        queryBody.departureDate.value = date as any;

        const _planningObject = {
          ...planningObject,
          departureSchedule: aux,
          departureDate: date,
          trip: returnStep === 0 ? "OUTWARD" : "RETURN",
        };

        setPlanningObject(_planningObject);

        tripApiCall(queryBody as PlanningObj);
      }
    } else {
      // TODO - si no viene el parámetro
    }
    setShowSubHeader(true);
  }, []);

  useEffect(() => {
    const aveSection = !!tripSelectedDetails
      ? tripSelectedDetails?.aveDeparture
      : aveSectionDefaultValue;
    setIsAveSelected(aveSection);
    const isReturnAveSelected = !!tripReturnSelectedDetails
      ? tripReturnSelectedDetails?.aveReturn
      : aveSectionDefaultValue;
    setIsReturnAveSelected(isReturnAveSelected);
  }, []);

  useEffect(() => {
    if (!!orderedTrips && orderedTrips.length > 0) {
      _setElementSelected(true);
    }
  }, [orderedTrips, filteredTrips, lenguage]);

  useEffect(() => {
    if (detailsSelector.length != 0) {
      if (sessionStorage.getItem("raas-language") != lenguage) {
        lenguage = sessionStorage.getItem("raas-language") as any;
        let trip = orderedTrips[selectIndex as any];
        let mapedDetail: any = mapTripToDetail(
          trip,
          planningObject.passengers,
          isReturnTrip,
          userConnected,
          t
        );
        filterTrips(
          bodyFilterTrips,
          getInitialUserFilter(),
          filtersOptions,
          trips
        );
        setDetailSelector(mapedDetail);
        setPlannerSubLiterals(plannerSubLiterals(t));
        setDriverCommentLiterals(initialDriverCommentLiterals(t));
        setbabyChairsLiterals(initialBabyChairsLiterals(t));
        setAveTariffLiterals(initialAveTariffLiterals(t));
        setFiltersOptions(getTransportFilterLiterals(t, filtersOptions));
        setDeletePlanificationModalLiterals(
          initialDeletePlanificationModalLiterals(t)
        );
      }
    }
  }, [filterOptions, lenguage]);

  useEffect(() => {
    let body = getSessionQuery();
    if (returnStep == 1) {
      setPlanningObject({ ...body, trip: "RETURN" });
      const invertidoBody = invertBodyData(body);
      tripApiCall(invertidoBody as PlanningObj, true);
    }
  }, [returnStep]);

  useEffect(() => {
    if (initialRender) {
      if (!!orderedTrips) {
        handleFiltersChange();
      }
    }
  }, [filtersOptions]);

  // useEfect para mostrar que no hay resultados
  useEffect(() => {
    if (initialRender) {
      if (filteredTrips.length == 0 && !isLoading()) {
        setShowNoResults(true);
      } else {
        setShowNoResults(false);
        // startScrollControl(); // scroll system
      }
    }
  }, [filteredTrips]);

  const addressFavCallStatus = useRef(false);
  useEffect(() => {
    if (addressFavCallStatus.current === false) {
      getFavoriteAddresses();
      addressFavCallStatus.current = true;
    }
  }, []);

  /* Cuando ya se ha añadido la silla, ya se haya construido el body, pues navegamos. */
  useEffect(() => {
    const isBabySeatAdded = noteDriverComment.find(
      (i) => i.type === "CHILD_SEAT"
    );
    if (!!isBabySeatAdded && mDetailRouteEvent) {
      // Simulo como que clico el botón pagar, necesario para reconstruir body con la info actualizada
      _setTripResumeDetailsInfo(mDetailRouteEvent);
      setTimeout(() => {
        checkNavigateNext();
      }, 1000);
    }
  }, [noteDriverComment]);

  const getFavoriteAddresses = () => {
    if (logged && userConnected?.addresses?.length > 0) {
      const addresses: Array<any> = userConnected.addresses;
      const mustHaveImperativeData: boolean = needImperativeData(addresses);
      if (mustHaveImperativeData) {
        getRealDataFav(
          addresses,
          (data: Array<any>) => {
            setItemStorage("addresses-fav", data || []);
          },
          () => {
            setItemStorage("addresses-fav", []);
          }
        );
      }
    }
  };

  const updateApiCall = () => {
    let body = getSessionQuery();
    tripApiCall(body as PlanningObj);
  };

  /**
   * @description función para navegar al siguiente paso
   */
  const navigateNext = () => {
    const path = getResumePath(departureAveSection, returnAveSection);
    const params = new URLSearchParams(window?.location?.search);
    sessionStorage.setItem("raas-url", "/trip-train");
    if (checkReturn() && returnStep == 0) {
      setReturnStep(1);
    } else if (checkReturn() && returnStep == 2) {
      navigate(path);
    } else {
      navigate(path);
    }
  };

  /**
   * @description función para saber si es un viaje de ida y vuelta
   */
  const checkReturn = () => {
    return isReturnTrip;
  };

  /**
   * @description función para resetear el estado de vuelta
   */
  const resetReturn = () => {
    setReturnStep(0);
  };

  /**
   *
   * @description función para seleccionar el detalle de un viaje
   */
  const _setElementSelected = (
    isDefaultSelected: boolean,
    ev?: CustomEvent
  ) => {
    setNoteDriverComment([]);
    setTariffTickets([]);
    const { index } = ev?.detail || indexSelectedObj;
    if (index !== selectIndex) {
      setShpCtxReturnTrainSelectedArray([]);
    }
    setSelectIndex(index);
    let trip = orderedTrips[index];
    setDisableDetailButton(false);

    // manageKarhooFleet(trip)
    setSelectedTrip(trip);

    let mapedDetail: any = mapTripToDetail(
      trip,
      planningObject.passengers,
      isReturnTrip,
      userConnected,
      t
    );

    const { hideDetail, karhooNotValidTarif, isFullTrain } =
      tripWithMissingTarif(trip, planningObject?.passengers);
    const isFromToTrainTripArray = mapedDetail?.filter(
      (item: any) => item?.fromToTrainTrip?.isFromToTrainTrip
    );
    setIsTariffMissing(false);
    if (hideDetail) {
      
      setDisableDetailButton(true);
    }
    if (karhooNotValidTarif) setDisableDetailButton(true);
    if (isFullTrain) setDisableDetailButton(true);

    if (planningObject.trip === "OUTWARD") {

      if (canNotBuyTrip(planningObject.departureDate.value)) {
        setDisableDetailButton(true)
      } else {
        setDisableDetailButton(false)
      }
    }

    if (planningObject.trip === "RETURN") {
      if (canNotBuyTrip(planningObject.arrivalDate.value)) {
        setDisableDetailButton(true)
      } else {
        setDisableDetailButton(false)
      }

    }

    let getAve = mapedDetail.find((item: any) => item?.icon === "ave") || [];
    if (getAve?.pricetag?.price === 0 && getAve?.pricetag?.type === "warn") {
      setDisableDetailButton(true);
    }

    let returnTrainTarif: any[] = getReturnAveModalTarif(
      isFromToTrainTripArray
    );
    const returnTrainSelected: any[] = setReturnTrainSelectedList(
      isFromToTrainTripArray
    );
    setShpCtxReturnTrainSelectedArray(returnTrainSelected);
    setFromToTickets(returnTrainTarif);

    //revisar
    let mapSummaryInfo: any = mapTripToSummary(trip, travellersList.length);
    setTripSummaryData(mapSummaryInfo);
    setDetailSelector(mapedDetail);
    setDetailPrice(calcCurrentPrice(mapedDetail, planningObject.passengers));
    setDetailPriceTotal(
      calcCurrentPriceTotal(mapedDetail, planningObject.passengers)
    );
    // cuando es cercanías o
    // updateTarifTickets(travellersList.length || 0);
    const passengersList = planningObject?.passengers?.value;
    setIndexSelectedRoute(index);
    dataLayerSelectItem(
      trip,
      filteredTrips,
      mapSummaryInfo,
      index,
      isReturnTrip,
      returnStep,
      filterTrip,
      mapedDetail
    );
    dataLayerViewItem(
      passengersList,
      mapedDetail,
      filterTrip,
      calcCurrentPrice(mapedDetail, planningObject.passengers),
      isReturnTrip,
      returnStep,
      trip,
      index
    );
  };

  /**
   * @description función que trae el viaje del storage si existe
   */
  const getSessionQuery = () => {
    const query = getItemStorage(SessionStorageItems.TRIP);
    if (query) {
      query.trip = returnStep === 0 ? "OUTWARD" : "RETURN";
      const departureDate = new Date(query.departureDate.value);
      const hours = "00",
        minutes = "00";
      const { date /*hours, minutes */ } = _checkisPastDate(
        departureDate,
        0,
        0
        /*+query.departureSchedule.value.hours,
        +query.departureSchedule.value.minutes*/
      );
      const aux = {
        hours,
        minutes,
        searchForArrival: 0, //query.departureSchedule.value.searchForArrival,
      };
      query.departureSchedule.value = aux as any;
      query.departureDate.value = date as any;
      if (!!query.arrivalDate?.value) {
        const arrivalDate = new Date(query.arrivalDate.value);

        const { date, hours, minutes } = _checkisPastDate(
          arrivalDate,
          1,
          1
          //+query.arrivalSchedule.value.hours,
          //*+query.arrivalSchedule.value.minutes
        );
        const aux = {
          hours,
          minutes,
          searchForArrival: 1, //query.arrivalSchedule.value.searchForArrival,
        };
        query.arrivalSchedule.value = aux as any;
        query.arrivalDate.value = date as any;
      }
      setPlanningObject(query);
    }
    return query;
  };

  /**
   * @description función que realiza la llamada al api
   * @param body
   * @param moreTime
   * @param leesWalk
   * @returns
   */
  const tripApiCall = (body: PlanningObj, removeLoading = false) => {
    if (body) {
      /*  if(detailsSelector?.length > 0 && window.location.origin == 'http://localhost:3000'){
         return;
       } */
      setIndexSelectedObject({ index: 0 });
      // const queryBody = returnStep != 0 ? invertBodyData(body) : body;
      const queryBody = body;
      const transportFilter = makeTransportFilterList();
      let dynamicQuery = mapTripQuery(
        queryBody,
        transportFilter?.transporFilters,
        returnStep === 0,
        transportFilter?.moreTime,
        transportFilter?.lessWalking
      );
      const query: string = "/trips-interval?" + dynamicQuery;
      if (body.origin.value.id === body.destination.value.id) {
        setInitialRender(true);
        setShowNoResults(true);
      } else {
        setDetailSelector([]);
        setShowNoResults(false);
        TripCall(
          query,
          (data: any) => {
            setInitialRender(true);
            if (data?.data?.Trip?.length > 0) {
              setTrips(data.data.Trip);
              setBodyFilterTrips(body);
              filterTrips(
                body,
                getInitialUserFilter(),
                filtersOptions,
                data.data.Trip
              );
            } else {
              setShowNoResults(true);
            }
            if (removeLoading) {
              //Reniciamos la variable de bono
              setBonoAveFree(false);
              setReturnStep(2);
            }
          },
          (err: any) => {
            console.log("HA OCURRIDO ALGUN ERROR: ", err);
            if (removeLoading) {
              setReturnStep(2);
            }
            setInitialRender(true);
            openToast(
              "error",
              t("literals.errorRequest"),
              t("literals.noChargeTrips")
            );
            emptyTrips();
          },
          removeLoading,
          window.sessionStorage["raas-trip-mock"]
        );
      }
      return body;
    }
  };
  const getInitialUserFilter = () => {
    let string = getFilterTravelPreference();
    setFilterTrip(string);
    return string;
  };
  const emptyTrips = () => {
    setTrips([]);
    filterTrips(planningObject, undefined, undefined, []);
  };
  const handleFilterType = (ev: CustomEvent) => {
    setShowNoResults(false);
    setShowNoResults(true);
    setPaginatorPage(1);
    const item = ev.detail.charAt(ev.detail.length - 1);
    setIndexSelectedObject({ index: 0 });
    filterTrips(planningObject, item);
    setFilterTrip(item);
  };
  const handleTranportFilter = (eventDetail: any) => {
    let aux = {
      ...filtersOptions,
      transportcard: eventDetail.transport,
      buttoncard: eventDetail.trip,
    };
    setFiltersOptions(aux);
  };

  const makeTransportFilterList = () => {
    const transportSelected = filtersOptions?.transportcard.filter(
      (item) => item?.selected
    );
    const trnsportBackFilter = transportSelected
      .map((item) => item?.backId)
      .join();
    return {
      transporFilters: trnsportBackFilter,
      moreTime: filtersOptions.buttoncard[1].selected,
      lessWalking: filtersOptions.buttoncard[0].selected,
    };
  };

  const handleFiltersChange = () => {
    let body = getSessionQuery();
    tripApiCall(body as PlanningObj);
  };

  const handleOpenModal = (ev: CustomEvent) => {
    setShowFiltersModal(true);
  };

  const closeFilters = (ev: CustomEvent) => {
    setShowFiltersModal(false);
    if (ev.detail) {
      handleTranportFilter(ev.detail); // aplicamos filtros de tranpsortes
      setCounterFilters(ev.detail); // pintamos nº de filtros en el botón
    }
  };

  /**
   * Setea el nº de filtros aplicados en el botón.
   * @param data Info proveniente de la modal ModalRight
   */
  const setCounterFilters = (data: any) => {
    let selectedTransports = [];
    selectedTransports = data?.transport?.filter((item: any) => item.selected);
    setNumberOfFilters(selectedTransports.length);
  };

  /**
   * Retorna la fecha de salida del viaje rellenado en el formulario, teniendo en cuenta si es ida o vuelta.
   * @param body Body del formulario del plannerbox
   * @returns Fecha de salida del viaje en la planificación
   */
  const getDatePlanification = (body: any) => {
    // aqui hay que usar siempre el departure porque le damos la vuelta al body
    const prefix = "departure";
    const dateTrip = body[prefix + "Date"]?.value;
    const dayPlanTrip = new Date(dateTrip).getDate();
    return dayPlanTrip;
  };

  /**
   * @description función que filtra los viajes y los ordena según las preferencias
   * @param body Formulario del plannerbox
   * @param tripFilter
   * @param optionsFilter
   * @param apiTrips
   */
  const filterTrips = (
    body: any,
    tripFilter?: any,
    optionsFilter?: any,
    apiTrips?: any
  ) => {
    let _travellerList = body.passengers;
    let initialTrips = apiTrips ? apiTrips : trips;
    let filters = "1";

    let options = optionsFilter ? optionsFilter : filtersOptions;

    const auxTrips = filterTripsFromService(initialTrips, options); // Filtramos los transportes permitidos.

    let auxOrderedTrips: any[] = [];
    const _dateTripPlan = getDatePlanification(body);

    let auxMapedTrips: Array<TripMaped | any> = auxTrips.map(
      (trip: any, index) => {
        let newTrip = mapResultTrip(
          trip,
          planningObject,
          t,
          _travellerList,
          _dateTripPlan,
          isReturnTrip
        );
        newTrip.idRuta = "jny_" + index;

        if (
          newTrip?.trasportSection?.length > 0 /*&&
          !!newTrip?.tripDayPlanified*/
        ) {
          return { ...newTrip, trip };
        }
      }
    );

    let auxMapedTripsWitoutUndefined = [...auxMapedTrips].filter(Boolean);
    // Filtrar solo viajes en la fecha planificada - RAASWEB-575

    setShowNoResultsByDate(auxMapedTripsWitoutUndefined.length === 0);

    // Filtramos por Rápidas, Económicas o Ecológicas (Filtros secundarios aplicados)

    /*auxMapedTripsWitoutUndefined = manageFilter(
      filters,
      auxMapedTripsWitoutUndefined
    );*/
    let aux = [] as any;
    const filter = auxMapedTripsWitoutUndefined.filter(
      (item) => item?.sortInfo?.price !== 0 && item.price !== "- €"
    );
    const minValue = Math.min(
      ...filter.map(
        (item) =>
          /*item.price !=="- €" ?item?.sortInfo?.price :0 */ item?.sortInfo
            ?.price
      )
    );
    auxMapedTripsWitoutUndefined.forEach((item) => {
      if (item?.sortInfo.price !== 0 && item?.sortInfo.price <= minValue) {
        aux.push({
          ...item,
          bestPrice: true,
        });
      } else {
        aux.push({
          ...item,
          bestPrice: false,
        });
      }
    });

    /*auxMapedTripsWitoutUndefined[posicion]={
      ...auxMapedTripsWitoutUndefined[posicion],
      bestPrice:auxMapedTripsWitoutUndefined[posicion]?.price!= '- €' ?true:false
    }*/

    aux = manageFilter("0", aux);

    // Almacenamos detalles de ruta
    aux.forEach((newTrip: any) => {
      if (
        newTrip?.trasportSection?.length > 0 /*&& !!newTrip?.tripDayPlanified*/
      ) {
        auxOrderedTrips.push({ ...newTrip.trip, price: newTrip.price });
      }
    });

    setOrderedTrips(auxOrderedTrips);
    setFilteredTrips(aux); // cards del paginator
  };

  /**
   * @description  Ordena según la preferencia seleccionada por el usuario.
   * El usuario puede filtrar sus rutas por rápido, económico y ecológico.
   * - Si el primer filtro es rápido o ecológico, el segundo filtro para ordenar será el económico.
   * - Si el primer filtro es el económico, el segundo filtro para ordenar será la rapidez.
   * @param order Filtro "Rapidas", "Económicas", "Ecológicas"
   * @param aux Array de trayectos
   */
  const manageFilter = (order: any, aux: TripMaped[]) => {
    if (order == "0") {
      //fast
      return aux.sort(filterByTime);
    } else if (order == "1") {
      //economic
      return aux.sort(filterByEconomicLongMover);
    } else if (order == "2") {
      //ecologic
      return aux.sort(filterByEcologic);
    }
    return aux;
  };

  const _makeTravellersList = (planningObject: PlanningObj) => {
    const passengersList = planningObject?.passengers?.value;
    const passengerMapped = {
      adult: Array(passengersList["more-than-13-counter"]).fill({
        type: "ADULT",
      }),
      child: Array(passengersList["less-than-13-counter"]).fill({
        type: "CHILD",
      }),
      baby: Array(passengersList["less-than-3-counter"]).fill({ type: "BABY" }),
    };
    const travellersBody = passengerMapped?.adult.concat(
      passengerMapped?.child,
      passengerMapped?.baby
    );
    setTravellersList(travellersBody);
    return travellersBody;
  };

  const handleSubHeaderPlanner = (ev: CustomEvent) => {
    const data = manageSubHeaderPlanner(ev, returnStep, t2); // contiene setPlanningObject y luego devuelve invertData.
    // console.log('[trazas] handleSubHeaderPlanner', data);
    if (data.action === "update") {
      updateCurrentTimeDate(data.obj.body, data.obj.msg);
    } else if (data.action === "call") {
      tripApiCall(data.obj);
    }
  };

  const manageSubHeaderPlanner = (
    ev: CustomEvent,
    returnStep: number,
    t: Function
  ): { action: string; obj: any } => {
    let body = ev.detail;
    const { ok, msg } = checkBookingDates(body, t, returnStep != 0);
    if (ok) {
      setPlanningObject(body);
      let obj = body;
      const objMapped: PlanningObj = mapPlanningObject(obj);
      if (returnStep != 0) {
        obj = invertBodyData(body);
      }
      _makeTravellersList(body);
      setItemStorage(SessionStorageItems.TRIP, objMapped);
      return { action: "call", obj };
    } else {
      return { action: "update", obj: { body, msg } };
    }
  };

  const checkBookingDates = (details: any, t?: any, inverse?: boolean) => {
    let ok = true;
    let msg = "";
    let { hours, minutes } = details?.departureSchedule?.value;
    let departureDate = new Date(details?.departureDate?.value);
    let departureFullDate = new Date(
      departureDate.getFullYear(),
      departureDate.getMonth(),
      departureDate.getDate(),
      parseInt(hours),
      parseInt(minutes)
    );
    let actualDate = new Date(
      new Date().getFullYear(),
      new Date().getMonth(),
      new Date().getDate(),
      new Date().getHours(),
      new Date().getMinutes()
    );

    //Ponemos horas a 0 porque no hay
    actualDate.setHours(0);
    actualDate.setMinutes(0);
    actualDate.setSeconds(0);

    if (!details.return) {
      ok = departureFullDate >= actualDate;
      if (!ok) msg = t("literals.previousDepartureDateCurrentDate");
    } else {
      hours = details?.departureSchedule?.value.hours;
      minutes = details?.departureSchedule?.value.minutes;
      let arrivalDate = new Date(details?.arrivalDate?.value);
      let arrivalFullDate = new Date(
        arrivalDate.getFullYear(),
        arrivalDate.getMonth(),
        arrivalDate.getDate(),
        parseInt(hours),
        parseInt(minutes)
      );
      ok =
        arrivalFullDate > departureFullDate && departureFullDate >= actualDate;
      if (!(arrivalFullDate > departureFullDate))
        msg = t("literals.previousArrivalDateDepartureDate");
      if (inverse && arrivalFullDate > departureFullDate)
        msg = t("literals.previousArrivalDateDepartureDate");
      if (!(departureFullDate >= actualDate))
        msg = t("literals.previousDepartureDateCurrentDate");
    }

    return { ok, msg };
  };

  const updateCurrentTimeDate = (body: any, msjerror: any) => {
    const isCurrentDate = checkISCurrentDate(body);
    if (isCurrentDate) {
      const departureSchedule = body.departureSchedule.value;
      if (departureSchedule.searchForArrival == "0") {
        // "Salir a las"
        const currentBool = checkDiffTimeFromCurrent(body);
        if (currentBool) {
          // Modificar body:
          body = modifyBodyCurrentDate(body);

          // Modificar inputs del formulario y el subplannerheader plegado:
          body.trip = returnStep === 0 ? "OUTWARD" : "RETURN";

          setPlanningObject(body);

          // Lanzar llamada.
          const obj = body;
          const objMapped: PlanningObj = mapPlanningObject(obj);
          if (returnStep == 2) {
            body = invertBodyData(body);
          }
          const travellersList = _makeTravellersList(body);
          setTravellersList(travellersList);
          setItemStorage(SessionStorageItems.TRIP, objMapped);
          tripApiCall(obj);
        } else {
          // cuando la diferencia es mayor a 1 hora.
          openToast("error", "Error", msjerror);
        }
      } else {
        // "llegar a las" no puede ser antes de la fecha actual!!
        openToast("error", "Error", msjerror);
      }
    }
  };

  const removeTrainReturnSelected = (index: number) => {
    const selectedTrainList: any = shpCtxReturnTrainSelectedArray;

    selectedTrainList[index] = undefined;
    setShpCtxReturnTrainSelectedArray([...selectedTrainList]);
  };

  const handleDeleteItemFromTripDetail = () => {
    let aux = detailsSelector;
    let index = indexDeleteItem;
    if (typeof index == "number") {
      // Gestión de borrados AVE y Cercanías.
      aux = manageDeleteAveCercanias(index, detailsSelector, t);

      aux = manageDeleteTransbordosMetros(index, aux, t);
      // Elimina el PST
      aux = deletePST(aux, index);

      aux = aux.filter((item) => !item.deleted);
      // Mapea y asigna botón de "Eliminar trayecto" a los pst primero y último.
      aux = checkMappedDeleteItems(aux);
      setDisableDetailButton(checkCompleteTrainsWhenDeleting(aux));
      setDetailSelector([...aux]);
      setDetailPrice(calcCurrentPrice([...aux], planningObject.passengers));
      setDetailPriceTotal(
        calcCurrentPriceTotal([...aux], planningObject.passengers)
      );
      setShowDeleteItemModal(false);
      removeTrainReturnSelected(shpCtxReturnIndexDeleteItem);
    }
  };

  const deletePST = (array: any[], index: number) => {
    if (index - 1 >= 0) {
      // comprobamos el paso anterior y si es un walk, lo borramos
      if (checkIsWalk(array[index - 1]?.icon)) {
        // borrado del elemento walk
        array.splice(index - 1, 1);
        // borrado del elemento index
        array.splice(index - 1, 1);
      } else {
        checkDeletedRoutes(array, index);
        //array.splice(index, 1);
      }
    } else {
      checkDeletedRoutes(array, index);
      //array.splice(index, 1);
    }
    return array;
  };

  const askDeleteItem = (ev: CustomEvent) => {
    const tripId = ev?.detail?.tripId;
    const pstTarifIndex = tripId[tripId?.length - 1];
    setShpCtxReturnIndexDeleteItem(Number(pstTarifIndex));
    setIndexDeleteItem(Number(ev?.detail?.id));
    setShowDeleteItemModal(true);
  };

  const openMissingMandatoryInfoModal = () => {
    setStep(2);
    setShowLoginModal(true);
  };
  const _makeLegListSection = (tripList: []) => {
    return (tripList || []).map((item) => item["trip"]);
  };

  const checkIfValid = () => {
    const shpCtxReturnTrainSelected =
      shpCtxReturnTrainSelectedArray.filter(Boolean);
    return isFromToSelectedAndValid(shpCtxReturnTrainSelected);
  };
  const _makeOutwardJourneySection = (trip: any) => {
    const arraySelectedTariffs: Array<any> = [];
    const isFromToTrainTrip = detailsSelector?.find(
      (item: any) => item?.fromToTrainTrip?.isFromToTrainTrip
    );
    const addNotesInFromTo = !!isFromToTrainTrip ? checkIfValid() : false;

    trip.forEach((item: any) => {
      const provider = getProvider(item.trip);
      const idLeg = item.trip.idx;
      const type = getProviderType(item.trip);
      if (["ave", "cercanias"].includes(type) && item.tarifs?.length > 0) {
        const id = item.pricetag.id;
        const tarif = item.tarifs.find((el: any) => el.id == id);
        const context =
          tarif && tarif.shpCtx ? tarif.shpCtx : item.tarifs[0].shpCtx;

        let tarifBodybody: any = {};

        tarifBodybody = {
          idLeg: +idLeg,
          provider: provider,
          contextType: "BOOKEE_CONTEXT",
          tickets: getContextPerPassenger([context], travellersList, type), // TODO: CONTEXTO POR PASAJERO Y/O POR TIPO DE PASAJERO (CHILD, BABY, ADULT)
          //...transportWithNotes?.includes(provider as string) && noteDriverComment?.length > 0 ? { notes: addCommentsToNotes(noteDriverComment, idLeg) } : {},
          ...(provider === "renfe-ave" && addNotesInFromTo
            ? {
              notes: [
                {
                  type: "ROUND_TRIP_TARIFF",
                  value: tarif?.fareSetItemIndex + "",
                },
              ],
            }
            : {}),
        };

        if (tarif && tarif.group) {
          const tarifs = item.allTarifsList.filter((el: any) => {
            if (el?.group?.type) {
              // petaba porque no venia el parametro group en objeto el
              return el.group.type == tarif?.group?.type;
            }
            return;
          });
          tarifBodybody.tickets = getContextPerPassengerByGroup(
            tarifs,
            travellersList,
            type
          );
        }

        let tripWithBono =
          item.pricetag.id == undefined && item.pricetag.price == 0;
        if (!tripWithBono) arraySelectedTariffs.push(tarifBodybody);
      }
    });
    const body = {
      trip: {
        Eco: selectedTrip?.Eco,
        Origin: selectedTrip?.Origin,
        LegList: { Leg: _makeLegListSection(trip) },
        checksum: selectedTrip?.checksum,
        Destination: selectedTrip?.Destination,
        TariffResult: selectedTrip?.TariffResult,
      },
      selectedTariff: [...arraySelectedTariffs],
    };
    return body;
  };
  const _makeSaveTripBody = (trip: any, isDeparture: boolean) => {
    const key = isDeparture ? "outwardJourney" : "returnJourney";

    return {
      [key]: _makeOutwardJourneySection(trip),
      travellers: travellersList,
    };
  };
  const _makeSummaryDetails = (isDeparture: boolean) => {
    const passagerNumberArray: Array<number> = Object.values(
      planningObject?.passengers?.value
    );
    const sum = passagerNumberArray.reduce(
      (prev, current) => prev + current,
      0
    );

    const date = isDeparture
      ? new Date(planningObject?.departureDate?.value)
      : new Date(planningObject?.arrivalDate?.value);
    let firstItem = detailsSelector[0];
    let lastItem = detailsSelector.slice(-1)[0];
    const textLiteral = isDeparture ? t("literals.go") : t("literals.back");
    return [
      {
        text: textLiteral,
        price: detailPrice?.desc,
        priceNumber: detailPrice?.sum,
        departure: isDeparture
          ? planningObject?.origin?.value?.name
          : planningObject?.destination?.value?.name,
        arrival: isDeparture
          ? planningObject?.destination?.value?.name
          : planningObject?.origin?.value?.name,
        date: date.toLocaleDateString("es-ES", {
          month: "short",
          day: "2-digit",
        }),
        rangetime: `${firstItem?.departureTime} - ${lastItem?.arrivalTime}`,
        num: String(sum),
        totalPriceWithoutExtras: detailPrice?.sum,
      },
    ];
  };
  const _getTextDetails = (item: TripDetail) => {
    return item.isExternal
      ? t("literals.ticketStation") + `${item?.stops ? item?.stops[0] : ""}`
      : `${item?.line?.text} ${item?.direction}`;
  };
  const _makeSummaryAmount = (ev: CustomEvent, isDeparture: boolean): any => {
    const transportList: TripDetail[] = ev.detail;
    const onlyTransportList = transportList.filter((item) => item.transport);
    const aproxList = onlyTransportList.filter(
      (item) => item.isAproximetePriceElement
    );
    const aproxAmount = aproxList.reduce(
      (prev, current) => prev + current?.pricetag?.price,
      0
    );
    const nowToPay = detailPrice?.sum - aproxAmount;
    const key = isDeparture ? "departure" : "arrival";
    let resultPrice = "";
    let isIncluding = false;
    return {
      [key]: {
        desglose: {
          now: nowToPay === 0 ? "0,00 €" : `${formatPrice(nowToPay)} €`,
          later: `${!!aproxAmount ? t("literals.approxPoint") : ""
            } ${formatPrice(aproxAmount)} €`,
          total: `${!!aproxAmount ? t("literals.approxPoint") : ""} ${detailPrice?.desc
            }`,
          totalAux: `${!!aproxAmount ? "" : ""} ${detailPrice?.desc}`,
          literal: `${!!aproxAmount ? t("literals.approxPoint") : ""}`,
          aproxPrice: aproxAmount,
        },
        transports: onlyTransportList.map((item) => {
          let transportReal;
          const transport = item?.icon;

          transportReal = item.transportTypeString;

          const pricetag = item?.pricetag;

          if (pricetag.price === null && transport == "cercanias") {
            resultPrice = item?.pricetag?.text;
            isIncluding = true;
          } else if (pricetag.price !== 0) {
            resultPrice = formatPrice(pricetag.price) + "€";
          } else if (
            item?.isExternal &&
            item?.realPriceTag.price == 0 &&
            pricetag.text.includes(
              t("literals.requiresExternalPurchaseNoPrice")
            )
          ) {
            resultPrice = t("literals.requiresExternalPurchaseNoPrice");
          } else if (item?.isExternal && item?.realPriceTag.price != 0) {
            resultPrice = t(formatPrice(item?.realPriceTag.price)) + "€";
          } else if (pricetag.text.includes(t("literals.includedTicket"))) {
            resultPrice = t("literals.includedTicket");
            isIncluding = true;
          } else {
            resultPrice = `${t("literals.includedTicket")}.`;
            isIncluding = true;
            // resultPrice = "" // controlar posibles casuisticas no cubiertas.
          }
          return item?.isAproximetePriceElement || item?.isCarTransport
            ? {
              idLeg: item?.idPst.replace(/[^0-9]+/g, ""),
              idTariff: item?.idTariff,
              informative: item?.pricetag?.informative,
              color: item?.line?.backgroundcolor,
              line: item?.line?.text,
              icon: item?.line?.icon,
              route: item?.trip?.Origin?.name,
              destiny: item?.trip?.Destination?.name,
              departureTime: item?.departureTime,
              arrivalTime: item?.arrivalTime,
              departureDate: item?.departureDate,
              transport: transportReal,
              bonoAveFree: item?.realPriceTag?.bonoAveFree || false,
              key: key,
              priceNumber: item?.pricetag?.price,
              totalPriceWithoutExtras: item?.realPriceTag?.price,
              passager: getPassengerNumber(),
              price: `${item?.isAproximetePriceElement ? t("literals.approx") : ""
                } ${formatPrice(item?.pricetag?.price)} €`,
              isPaidTrip: false,
            }
            : {
              idLeg: item?.idPst.replace(/[^0-9]+/g, ""),
              idTariff: item?.idTariff,
              informative: item?.pricetag?.informative === undefined ? false : true,
              color: item?.line?.backgroundcolor,
              line: item?.line?.text,
              icon: item?.line?.icon,
              route: item?.trip?.Origin?.name,
              destiny: item?.trip?.Destination?.name,
              departureTime: item?.departureTime,
              arrivalTime: item?.arrivalTime,
              departureDate: item?.departureDate,
              transport: transportReal,
              isIncluding: isIncluding,
              bonoAveFree: item?.realPriceTag?.bonoAveFree || false,
              key: key,
              priceNumber: item?.pricetag?.price,
              totalPriceWithoutExtras: item?.realPriceTag?.price,
              passager: getPassengerNumber(),
              price: `${item?.isAproximetePriceElement ? t("literals.approx") : ""} ${formatPrice(item?.pricetag?.price)} €`,
              isPaidTrip: false,
              details: [
                {
                  icon: item?.icon,
                  text: _getTextDetails(item),
                  external: item?.isExternal,
                  price: resultPrice,
                  //price: `${item?.pricetag?.price !== 0 ? formatPrice(item?.pricetag?.price) + "€": t("literals.includedTicket")} `,
                },
              ],
            };
        }),
      },
    };
  };

  const getDate = (isDeparture: boolean) => {
    // OJO, que aqui se han invertido al ser ida y vuelta.
    const date = isDeparture
      ? new Date(planningObject?.departureDate?.value)
      : new Date(planningObject?.arrivalDate?.value);
    const dateWithFormat = date.toLocaleDateString("es-ES", {
      month: "short",
      day: "2-digit",
    });
    return {
      ...(isDeparture
        ? { departureDate: dateWithFormat }
        : { returnDate: dateWithFormat }),
    };
  };

  const getPassengerNumber = (): number => {
    const passengerObj = planningObject?.passengers?.value;
    const passagerNumberArray = Object.values(passengerObj);
    const sum: number = passagerNumberArray.reduce(
      (prev: any, current: any) => prev + current,
      0
    ) as number;
    return sum;
  };

  const getPassengerNumberByCode = (code: string) => {
    const passengerObj = planningObject?.passengers?.value;
    return passengerObj[code];
  };

  const mapSummaryAveStepper = (aveList: any, isDeparture: boolean): any => {
    const allPassenger = getPassengerNumber();
    const dateObject = getDate(isDeparture);
    const summary = (aveList || []).map((item: any) => {
      const childTarif =
        !!item?.childTarif && !emptyArray(item?.childTarif)
          ? item?.childTarif[0]
          : null;
      let tarifSelected = item?.tarifSelected;

      /*if(bonoAveFree){
        tarifSelected={
          ...item?.tarifSelected,
        price: item?.priceTag?.price / allPassenger,
          
        }
      }*/
      const totalTicketPrice = item?.priceTag?.price;

      return {
        origin: item?.origin,
        direction: item?.direction,
        allPassengerTicketPrice: totalTicketPrice,
        childTarif: childTarif,
        adultTarif: tarifSelected,
        allPassangerNum: allPassenger,
        aveName: item?.aveName,
        arrivalTime: item?.arrivalTime,
        departureTime: item?.departureTime,
        //fullDepartureDate: getDepartureDate(item?.departureDate),
        fullDepartureDate: item?.departureDate,
        isSilentCar: item?.isSilentCar,
        bonoAveFree: item?.priceTag?.bonoAveFree
          ? item?.priceTag?.bonoAveFree
          : false,
        ...dateObject,
      };
    });
    return summary;
  };

  const getDiscountList = (tarifsArray: any, discuntCode: string) => {
    return tarifsArray?.filter(
      (item: any) =>
        item?.group?.type === discuntCode &&
        item?.group?.child === false &&
        !!item?.group?.discount
    );
  };

  const getChildTarif = (tarifsArray: any, discuntCode: string) => {
    return tarifsArray?.filter(
      (item: any) =>
        item?.group?.type === discuntCode &&
        item?.group?.child === true &&
        !item?.group?.discount
    );
  };

  const aveMapSection = (aveList: any, isDeparture: boolean) => {
    return (aveList || []).map((item: any) => {
      const stopsArray = item?.stops;
      let firstStop = !!stopsArray ? stopsArray[0] : "";
      let lastStop = !!stopsArray ? stopsArray.slice(-1)[0] : "";
      const tarifSelected = item?.tarifs?.find(
        (ta: any) => ta?.shpCtx === item?.pricetag?.shpCtx
      );
      const discountList = getDiscountList(
        item?.allTarifsList,
        tarifSelected?.group?.type
      );
      const childTarif = getChildTarif(
        item?.allTarifsList,
        tarifSelected?.group?.type
      );

      return {
        title: isDeparture ? t("literals.go") : t("literals.back"),
        discountList: discountList,
        tarifSelected: tarifSelected,
        childTarif: !isEmptyArray(childTarif)
          ? childTarif
          : [tarifSelected].filter(Boolean),
        origin: firstStop,
        direction: lastStop,
        aveName: item?.line?.text,
        priceTag: item?.pricetag,
        arrivalTime: item?.arrivalTime,
        departureTime: item?.departureTime,
        departureDate: item?.departureDate,
        isSilentCar: item?.pricetag?.isSilentCar,
      };
    });
  };

  const _checkIfTripIncludeAVE = (
    ev: CustomEvent,
    isDeparture: boolean
  ): void => {
    const transport = ev.detail;
    const includesAve = transport.filter((elem: any) => elem?.icon === "ave");
    const notAveTransport = transport.filter(
      (elem: any) => elem?.icon !== "ave"
    );
    const aveMap = aveMapSection(includesAve, isDeparture);

    const adultNumber = getPassengerNumberByCode("more-than-13-counter");
    const childNumber = getPassengerNumberByCode("less-than-13-counter");
    const payedPassengerNumber = adultNumber + childNumber;

    const isAve = includesAve?.length > 0;
    const otherTransportPrice = notAveTransport?.reduce(
      (prev: any, current: any) => {
        return prev + current?.pricetag?.price;
      },
      0
    );

    if (isDeparture) {
      const summaryDeparture = mapSummaryAveStepper(aveMap, isDeparture);
      departureAveSection = {
        payedPassengerNumber,
        isAveSelected: isAve,
        aveTripList: aveMap,
        summarySection: {
          otherTransportPrice: Number(otherTransportPrice),
          aveSummaryList: summaryDeparture,
        },
      };
      setIsAveSelected(departureAveSection);
    } else {
      const summaryReturn = mapSummaryAveStepper(aveMap, isDeparture);
      returnAveSection = {
        payedPassengerNumber,
        isAveSelected: isAve,
        aveTripList: aveMap,
        summarySection: {
          otherTransportPrice: Number(otherTransportPrice),
          aveSummaryList: summaryReturn,
        },
      };
      setIsReturnAveSelected(returnAveSection);
    }
  };

  const _setTripResumeDetailsInfo = (ev: CustomEvent): void => {
    const isDeparture = returnStep === 0;
    _checkIfTripIncludeAVE(ev, isDeparture);
    const bodySection: IBodyTripSelected = _makeSaveTripBody(
      ev?.detail,
      isDeparture
    );
    const summarySection = _makeSummaryDetails(isDeparture);
    const tripSummaryDetails: ITripSelectedDetails = {
      body: bodySection,
      summary: summarySection,
      summaryAmount: _makeSummaryAmount(ev, isDeparture),
      aveDeparture: departureAveSection,
      aveReturn: returnAveSection,
    };

    // TODO - Cuidado aquí se están pasando en el sumari el pago de taxi a 6€ pero debería ser 0;
    if (isDeparture) {
      setTripSelectedDetails(tripSummaryDetails);
      setTripSummaryDetail(tripSummaryDetails);
      setTypeTrip({ type: "departure" });
    } else {
      setReturnTripSelectedDetails(tripSummaryDetails);
      setReturnTripSummaryDetail(tripSummaryDetails);
      setTypeTrip({ type: "arrival" });
    }

    //dataLayerAddToCart(tripSummaryDetails,typeTrip,detailsSelector,filterTrip)
    if (logged) {
      dataLayerAddToCart(
        selectedTrip,
        filteredTrips,
        tripSummaryData,
        indexSelectedRoute,
        isReturnTrip,
        returnStep,
        filterTrip,
        detailPrice
      );
    }
  };

  const isFromToSelectedAndValid = (
    shpCtxReturnTrainSelectd: IReturnTrainStateControlObject[]
  ) => {
    const allPstReturnTrainAreSelected = shpCtxReturnTrainSelectd.every(
      (item) => item?.isFromToTarifSelected
    );
    const allPstAreSelectedTrainTarif = shpCtxReturnTrainSelectd.every(
      (item) => item?.isTrainReturnSelected
    );
    return allPstReturnTrainAreSelected && allPstAreSelectedTrainTarif;
  };

  const checkReturnTrainTarifSelected = () => {
    const shpCtxReturnTrainSelected =
      shpCtxReturnTrainSelectedArray.filter(Boolean);

    const navigateToFakeReturn = isFromToSelectedAndValid(
      shpCtxReturnTrainSelected
    );
    const onePstReturnTrainAreSelected = shpCtxReturnTrainSelected.some(
      (item) => item?.isFromToTarifSelected
    );
    const adultNumber = getPassengerNumberByCode("more-than-13-counter");
    const childNumber = getPassengerNumberByCode("less-than-13-counter");
    const payedPassengerNumber = adultNumber + childNumber;

    navigateToFakeReturn &&
      mapReturnFromToAveDetail(
        shpCtxReturnTrainSelectedArray,
        payedPassengerNumber,
        selectedTrip,
        planningObject
      );

    navigateToFakeReturn
      ? navigate("/return-ave")
      : onePstReturnTrainAreSelected && !navigateToFakeReturn
        ? setIsTrainRequestedFromBuyButton(true)
        : setReturnStep(1);
  };

  const checkNavigateNext = () => {
    if (checkReturn() && returnStep === 0) {
      const isFromToTrainTrip = detailsSelector?.find(
        (item: any) => item?.fromToTrainTrip?.isFromToTrainTrip
      );
      !!isFromToTrainTrip ? checkReturnTrainTarifSelected() : setReturnStep(1);
    } else {
      if (logged) {
        const missingMandatoryInfo = userConnected?.missingMandatoryInfo;
        // force mandatory info
        if (missingMandatoryInfo) {
          openMissingMandatoryInfoModal();
          return;
        } else {
          navigateNext();
        }
      } else {
        setShowLoginModal(true);
      }
    }
  };

  const handleSelectRoute = (ev: CustomEvent) => {
    saveMDetailRouteEvent(ev);
    _setTripResumeDetailsInfo(ev);

    handleSelectRouteModals(ev, () => {
      checkNavigateNext();
    });
    //Pagar
  };

  const handleSelectRouteModals = (ev: any, callback: Function) => {
    const transport = ev.detail;

    callback();
  };

  const handleUploadDocument = () => {
    setShowUploadDocument(false);
    setAccessToAppLiterals(initialAccessToAppMotoLiterals(t));
    setShowAccessToApp(true);
  };
  const threemodalsflow = () => {
    setShowUploadDocument(true);
  };

  const mapModalTarif = (tarifTypes: any, item: any) => {
    setTariffTickets(tarifTypes);
    const tariffTicketsRefact = tarifTypes;

    //seteo los literales
    setTariffLiterals(setTarifsLiterals(item, t));

    //seteo el bono
    setTarifBono(getTarifBono(item));

    //seteo el address final
    setTarifAdress(item.direction);
    //seteo las tarifas

    setTariffFilters([]);
    //seteo el tag
    setTariffTag({
      text: item.line?.text,
      color: item.line?.color,
      backgroundcolor: item.line?.backgroundcolor,
      bordercolor: item.line?.bordercolor,
    });

    if (whatTransportIs(item) == travelServices.ave) {
      setShowAveTariff(true);
    } else {
      setShowTarif(true);
    }
  };

  const checkIfSilenceCarHasFreeSeats = (
    carsTrainList: any,
    travellersNumber: number
  ) => {
    const silentCarObject = carsTrainList?.find(
      (item: any) => !!item?.othersFeatures
    );
    const numSeatFree = +silentCarObject?.numSeatFree || 0;
    return numSeatFree >= travellersNumber;
  };

  const handleChangeTarif = (ev: CustomEvent) => {
    const { detail } = ev;

    const { id } = detail;
    setDetailIndexSelected(id);
    setIdPstNotChangeable(detail?.isPstNotChangeable);

    setTrainModalTariffSelected([]);
    // const item = detailsSelector[parseInt(id)]
    const item = detailsSelector.find((item) => item.idPst === id);
    const tarifs = item?.tarifs;
    //seteo las tarifas
    const childCount = getPassengerNumberByCode("less-than-13-counter");
    const adultCount = getPassengerNumberByCode("more-than-13-counter");
    const tarifSelected = item?.pricetag?.shpCtx;
    let transport = whatTransportIs(item);
    const isAveAndPosibleSilentCar =
      transport === travelServices.ave && item?.silentCar?.isSilent;
    let tarifTypes = [];
    const isReturnTrainSelected =
      shpCtxReturnTrainSelectedArray[id]?.isTrainReturnSelected;

    if (isAveAndPosibleSilentCar) {
      getSeatTrainMapCallPromise(tarifSelected)
        .then((response: any) => {
          const tariffsResponse = response?.data?.tariffs[0];
          const carsList = tariffsResponse.hasOwnProperty("cars")
            ? tariffsResponse?.cars
            : [];
          const travellersNumber = childCount + adultCount;
          const silenceCarHasFreeSeats = checkIfSilenceCarHasFreeSeats(
            carsList,
            travellersNumber
          );
          tarifTypes = setTarifs(
            tarifs,
            item,
            childCount,
            adultCount,
            silenceCarHasFreeSeats,
            !!isReturnTrainSelected,
            t
          );
          mapModalTarif(tarifTypes, item);
        })
        .catch(() => {
          tarifTypes = setTarifs(
            tarifs,
            item,
            childCount,
            adultCount,
            false,
            !!isReturnTrainSelected,
            t
          );
          mapModalTarif(tarifTypes, item);
        });
    } else {
      tarifTypes = setTarifs(
        tarifs,
        item,
        childCount,
        adultCount,
        false,
        !!isReturnTrainSelected,
        t
      );
      // Si es taxi: Filtrar nº de pasajeros que pueda llevar dicho transporte --> APLICA A TODOS LOS VTC/taxi excepto Movitaxi
      if (
        item.transportTypeString === "Taxi/VTC" ||
        item.transportTypeString === "Bolt"
      ) {
        const totalPassengers = childCount + adultCount;
        tarifTypes = tarifTypes.filter(
          (item: any) => item.numpersons >= totalPassengers
        );
      }
      mapModalTarif(tarifTypes, item);
    }
  };

  const handleBonoClick = () => {
    setShowTarif(false);
    setShowAveTariff(false);
    // setear el precio del viaje a 0;
    detailsSelector.find(
      (item) => item.idPst === detailIndexSelected
    ).pricetag = {
      ...detailsSelector.find((item) => item.idPst === detailIndexSelected)
        .pricetag,
      text: `${0} €` + t("literals.haveBonus"),
      price: 0,
      id: undefined,
      bonoAveFree: true,
    };
    detailsSelector.find(
      (item) => item.idPst === detailIndexSelected
    ).realPriceTag = {
      ...detailsSelector.find((item) => item.idPst === detailIndexSelected)
        .realPriceTag,
      price: 0,
      bonoAveFree: true,
    };

    //setBonoAveFree(true)
    setDetailSelector([...detailsSelector]);
    setDetailPrice(
      calcCurrentPrice(detailsSelector, planningObject.passengers)
    );
    setDetailPriceTotal(
      calcCurrentPriceTotal(detailsSelector, planningObject.passengers)
    );
  };
  const handleOpenComment = (ev: CustomEvent) => {
    setShowTarif(false);
    setShowAveTariff(false);
    setShowDriverComment(true);
  };

  const handleSelectionVehicle = (ev: CustomEvent) => {
    if (ev?.detail) {
      // almaceno info para cuando se envie comentarios al conductor
      setselectionVehicleEvent({ detail: ev.detail });
    }
  };

  const resetTrainReturnSelected = () => {
    const selectedTrainList = shpCtxReturnTrainSelectedArray;

    selectedTrainList[+idPstNotChangeable] = {
      isFromToTarifSelected: false,
      isTrainReturnSelected: false,
      trainReturnTarifSelected: "",
    };
    setShpCtxReturnTrainSelectedArray([...selectedTrainList]);
  };

  const handleSelectVehicle = (ev: CustomEvent, isAve: boolean) => {
    let aux = tariffTickets.map((card: any) => {
      return {
        ...card,
        isTrainSelected: card.id == ev.detail.id ? true : false,
      };
    });
    setTariffTickets(aux);

    const returnTrainObjectControl = ev?.detail?.isFromToTarifSelected
      ? shpCtxReturnTrainSelectedArray[+idPstNotChangeable]
      : undefined;
    const isReturnSelected = checkIfReturnTrainIsSelected(
      returnTrainObjectControl
    );
    !returnTrainObjectControl &&
      !!shpCtxReturnTrainSelectedArray[+idPstNotChangeable] &&
      resetTrainReturnSelected();
    setSelectedRateSilentCar(ev.detail.switchToggled);

    if (!isReturnSelected) {
      if (isAve && ev.detail.switchToggled === true) {
        setShowSilentCardModal(true);
      }
      setIsTrainRequested(true);
      setShowAveTariff(false);

      window.dataLayer?.push({
        event: "page_view",
        screen_name: "terms_and_conditions_alert",
        screen_class: "registration_alert",
      });
      return;
    }

    updateRatePriceSilentCar(ev);
    setShowTarif(false);
    setShowAveTariff(false);
  };

  const updateRatePriceSilentCar = (ev: any) => {
    if (ev) {
      // cambio el precio y actualizo precio del viaje.
      if (ev?.detail) {
        let price = 0;
        let priceAux = ev?.detail?.price?.split("€");
        let specjourney = detailsSelector?.find(
          (item) => item?.idPst === detailIndexSelected
        );

        let index_tarif = specjourney?.tarifs[ev?.detail?.id];
        let terms = index_tarif?.param?.find(
          (item: any) => item?.name === "TERMS_AND_CONDITIONS_LINK"
        );

        //Dentro del whatTransportIs se ha cambiado detailsSelector[detailIndexSelected] por esto:
        if (
          whatTransportIs(
            detailsSelector.find((item) => item.idPst === detailIndexSelected)
          ) === travelServices.train
        ) {
          //si es tren, multiplicamos por los billetes
          let priceAuxFloat = priceAux[0].split(",").join(".");
          price =
            (parseFloat(priceAuxFloat) * ev.detail.numcounter * 100) / 100;
        } else if (
          whatTransportIs(
            detailsSelector.find((item) => item.idPst === detailIndexSelected)
          ) === travelServices.ave
        ) {
          price = getTotalPriceFromtravellerListByTarif(
            selectedTrip,
            +idPstNotChangeable,
            planningObject?.passengers,
            index_tarif.group.type
          );
        } else {
          price = +priceAux[0].split(",").join("."); //+ = parse to number
        }
        detailsSelector.find(
          (item) => item.idPst === detailIndexSelected
        ).pricetag = {
          ...detailsSelector.find((item) => item.idPst === detailIndexSelected)
            .pricetag,
          text: `${formatPrice(price)} € - ${ev.detail.desc}`,
          price: price,
          isSilentCar: ev?.detail?.switchToggled,
          shpCtx: ev?.detail?.shpCtx,
          id: index_tarif?.id,
        };
        detailsSelector.find(
          (item) => item.idPst === detailIndexSelected
        ).pricetag = {
          ...detailsSelector.find((item) => item.idPst === detailIndexSelected)
            .pricetag,
          text: `${formatPrice(price)} € - ${ev.detail.desc}`,
          price: price,
        };

        // cambiamos el nombre de la flota si es un taxi o vtc
        if (
          detailsSelector.find((item) => item.idPst === detailIndexSelected)
            .icon === "taxiVtc"
        ) {
          detailsSelector.find(
            (item) => item.idPst === detailIndexSelected
          ).line.text = updateFleetName(
            detailsSelector.find((item) => item.idPst === detailIndexSelected)
              .tarifs,
            ev.detail.id
          );
        }

        setFleetKarhooName({
          name: specjourney?.line?.text,
          url: terms?.value || "",
        });
        setFleetSessionName({
          name: specjourney?.line?.text,
          url: terms?.value || "",
        });

        setDetailSelector([...detailsSelector]);

        setDetailPrice(
          calcCurrentPrice(detailsSelector, planningObject.passengers)
        );
        setDetailPriceTotal(
          calcCurrentPriceTotal(detailsSelector, planningObject.passengers)
        );
      }
    }
    setShowSilentCardModal(false);
  };

  /**
   * @description función que retorna la flota de un nueva tarifa seleccionada
   * @param tarifs
   * @param desc
   */
  const updateFleetName = (tarifs: any[], id: number) => {
    return tarifs[id].desc;
  };

  const callLoginMicroService = (data: { email: string; password: string }) => {
    setEmail(data?.email);
    setPass(data?.password);
    let loginBody = {
      username: data?.email,
      password: data?.password,
      deviceKey: getDeviceKey(),
    };
    postAxios(apiNames.IDENTITY, false, "/sessions/login", loginBody)
      .then((response: any) => {
        setLoginToken(response?.data?.token);
        if (response.status === 206) {
          window.dataLayer?.push({
            event: "login",
            method: "email",
          });
          openToast(
            "success",
            t("literals.sendEmail"),
            t("literals.findYourCodeIn") + t("literals.yourEmail") + data?.email
          );
          setStep(1);
        } else {
          okLogin(response?.data);
        }
      })
      .catch(() => {
        let literal = t("literals.anErrorOccurred");
        window.dataLayer?.push({
          event: "screen_view",
          screen_name: "email",
          screen_class: "error_login",
        });
        openToast("error", t("literals.error"), literal);
      });
  };
  const okLogin = (data: any) => {
    setSession(data);
    setStorage(data);
    setLogged(true);
    getData();
  };
  const getData = () => {
    getUserData(
      (response: any) => {
        const userDataResponse = response?.data;
        // setItemStorage(SessionStorageItems.RAAS_USER);
        setUserDetail(userDataResponse);
        setUserConnected(userDataResponse);
        setShowLoginModal(false);

        checkForMinors(userDataResponse, () => {
          // Se ejecuta el callback si se ha checkeado bien.
          const missingMandatoryInfo = userDataResponse?.missingMandatoryInfo;
          let path = getResumePath(departureAveSection, returnAveSection);
          if (loggedSocial) {
            path = getResumePath(
              tripSelectedDetails.aveDeparture,
              tripSelectedDetails.aveReturn
            );
          } else {
            path = getResumePath(departureAveSection, returnAveSection);
          }
          missingMandatoryInfo ? setStep(2) : navigate(path);
        });
      },
      () => {
        openToast("error", "Error", t("literals.tryAgainLater"));
      }
    );
  };

  const handleOpenMail = () => {
    openMail(email);
  };
  const handleReSendEmail = () => {
    openToast(
      "success",
      t("literals.sendEmail"),
      t("literals.findYourCodeIn") + t("literals.yourEmail") + email
    );
    let loginBody = {
      username: email,
      password: password,
      deviceKey: getDeviceKey(),
    };
    postAxios(apiNames.IDENTITY, false, "/sessions/login", loginBody)
      .then((response: any) => {
        setLoginToken(response?.data?.token);
        if (response.status === 206) {
          setStep(1);
        } else {
          okLogin(response?.data);
        }
      })
      .catch(() => {
        // TODO literles porne en todos los idiomas esta solo en español
        let literal = t("literals.anErrorOccurred");
        openToast("error", "Error", literal);
      });
  };
  const hadleVerifyMail = (data: any) => {
    const code = data?.detail;
    let verifyBody = {
      token: loginToken,
      email,
      code,
    };
    postAxios(
      apiNames.IDENTITY,
      false,
      "/sessions/verification-code",
      verifyBody
    )
      .then((response: any) => {
        if (response?.status == 206) {
          setLoginToken(response?.data?.token);
          openToast("error", "Error", t("literals.incorrectCode"));
        } else {
          if (document.body.style?.overflow === "hidden") {
            document.body.style.overflow = "auto";
          }
          okLogin(response?.data);
        }
      })
      .catch((error: any) => {
        if (error?.status === 400) {
          openToast("error", "Error", t("literals.incorrectCode"));
        } else if (error.status === 401) {
          openToast("error", "Error", t("literals.wrongEmailPassword"));
          setStep(0);
        }
      });
  };
  const goToProfile = () => {
    navigate("/personal-data?goTo=/trip-train");
  };

  const checkCooltra = () => {
    if (!logged) {
      setShowAccessToApp(false);
      getModalSlot(0);
      setShowLoginModal(true);
    } else {
      setShowAccessToApp(false);
      navigateNext();
    }
  };

  const handleLoginSocial = ({ detail }: CustomEvent) => {
    window.dataLayer?.push({
      event: "select_content",
      screen_name: "welcome",
      screen_class: "onboarding",
      content_name: "social_login",
      content_type: detail,
    });
    getPromiseByProvider(detail);
  };

  const getModalSlot = (currentStep: number) => {
    switch (currentStep) {
      case 0:
        return (
          <UserLoginModal
            literals={JSON.stringify(LoginModalLiterals(t))}
            react-path-navigation={JSON.stringify(ReactPathNavigation)}
            onCloseModal={() => setShowLoginModal(false)}
            onLoginEventClick={(e: any) => callLoginMicroService(e.detail)}
            onNavigateToEventClick={(e: any) => navigate(e.detail)}
            onLoginSocialClicked={handleLoginSocial}
          ></UserLoginModal>
        );
      case 1:
        return (
          <ConfirmLoginMail
            literals={JSON.stringify(literalsConfirmEmail)}
            mail={email}
            onResendMail={handleReSendEmail}
            onOpenMail={handleOpenMail}
            onVerifyEmail={hadleVerifyMail}
            onBackPage={() => setStep(0)}
            onCloseModal={() => setShowLoginModal(false)}
          />
        );
      case 2:
        return (
          <IncompletePersonalData
            literals={JSON.stringify(PersonalDataModalLiterals(t))}
            onCancelClickEvent={() => setShowLoginModal(false)}
            onGoToProfileClickEvent={() => goToProfile()}
          />
        );
    }
  };

  const handleSendTrainRequest = () => {
    setShowAveTariff(false);
    setShowFromToTrainList(true);
    //setShowSilentCardModal(true);

    const returnTrainList = [...fromToTickets[idPstNotChangeable]];
    const dateFilter = [] as any;
    let hour = ~~bodyFilterTrips?.arrivalSchedule.value.hours;
    let minute = ~~bodyFilterTrips.arrivalSchedule.value.minutes;
    let typeTrip =
      bodyFilterTrips?.arrivalSchedule?.value?.searchForArrival === "1"
        ? "llegar"
        : "salir";
    const timeBackCheck = new Date();
    timeBackCheck.setHours(hour);
    timeBackCheck.setMinutes(minute);

    //Hora de llegada/Vuelta

    returnTrainList.forEach((element) => {
      let hourAux = ~~element.tripOptions.departureTime.substring(0, 2);
      let minuteAux = ~~element.tripOptions.departureTime.substring(5, 3);
      const timeTariff = new Date();
      timeTariff.setHours(hourAux);
      timeTariff.setMinutes(minuteAux);

      let horasTarifa = timeTariff.getHours();
      let minutosTarifa = timeTariff.getMinutes();

      let horasViaje = timeBackCheck.getHours();
      let minutosViaje = timeBackCheck.getMinutes();

      //Si son las mismas horas comparamos minutos

      if (typeTrip === "salir") {
        if (horasViaje === horasTarifa) {
          if (minutosTarifa >= minutosViaje) {
            dateFilter.push(element);
          }
        } else {
          if (horasViaje < horasTarifa) {
            dateFilter.push(element);
          }
        }
      } else {
        if (horasViaje === horasTarifa) {
          if (minutosTarifa <= minutosViaje) {
            dateFilter.push(element);
          }
        } else {
          if (horasViaje > horasTarifa) {
            dateFilter.push(element);
          }
        }
      }
    });

    if (dateFilter.length != 0) {
      dateFilter[0].fromToSelected = true;
      setTrainModalTariffSelected(dateFilter);
    }
  };

  const saveTrainSelected = () => {
    const tariffTicketsModified = tariffTickets.map((item: any) => {
      if (item?.isFromTo) {
        return {
          ...item,
          isTrainSelected: true,
        };
      }
      return item;
    });
    setTariffTickets(tariffTicketsModified);
  };

  const handleSelectTrainTarifSelected = (ev: CustomEvent) => {
    const eventDetailObject = ev?.detail;
    const shpCtx = eventDetailObject?.shpCtx;
    const idPstNotChangeable = eventDetailObject?.idPstNotChangeable;
    const selectedTrainList = shpCtxReturnTrainSelectedArray;

    selectedTrainList[idPstNotChangeable] = {
      isFromToTarifSelected: eventDetailObject?.isFromToTarifSelected,
      isTrainReturnSelected: eventDetailObject?.isTrainSelected,
      trainReturnTarifSelected: shpCtx,
      trainTripCardInfo: eventDetailObject?.trainTripCardInfo,
      outwardTripPst: eventDetailObject?.outwardTripPst,
      tarifSelected: eventDetailObject?.tarifSelected,
    };
    setShpCtxReturnTrainSelectedArray([...selectedTrainList]);
    saveTrainSelected();
    setIsTrainSelected(true);
    setShowFromToTrainList(false);
  };

  /* DOCO-684: CONTROL UNDER16 AGE */
  const okModalUnder16 = () => {
    window.dataLayer?.push({
      event: "select_content",
      screen_name: "legal_age_needed_alert",
      screen_class: mappingScreenNameAnalytics(window.location.pathname),
      content_type: "button",
      content_name: "add_legal_age",
    });
    setShowModalUnder16(false);
    navigate("/personal-data?goTo=/trip-train");
  };
  /* AgeConfirmation Modal: confirmo que soy mayor de 16 años */
  const handleCloseModalClick = () => {
    /* Cierro todas las modales */
    setIsOver16(false);
    setConfirmationAge(false);
    setShowModalUnder16(false);

    /* Actualizo la variable under16 a false */
    apiUpdateUnder16Age(
      false,
      (userData: any) => {
        /* Vuelvo a comprobar, por si birthDate viene null */
        setShowLoginModal(false);
        checkForMinors(userData);
      },
      (err: any) => {
        console.warn("Algo ha ido mal: ", err);
      }
    );
  };
  /* AgeConfirmation Modal: soy menor de 16, boton "Entendido" */
  const handleUnderstoodClick = () => {
    setIsOver16(false);
    setConfirmationAge(false);
    apiUpdateUnder16Age(
      true,
      () => {
        setShowLoginModal(false);
        setStep(0);
        logoutClick();
      },
      (err: any) => {
        console.warn("Algo ha ido mal: ", err);
      }
    );
  };
  const checkForMinors = (data: any, callback?: Function) => {
    const checkId = checkUnder16(data);
    switch (checkId) {
      case CHECKAGE.askRequired:
        setIsOver16(false);
        setConfirmationAge(true);
        break;
      case CHECKAGE.isUnderAge:
        setIsOver16(false);
        setConfirmationAge(true);
        break;
      case CHECKAGE.mandatoryAgeNeeded:
        window.dataLayer?.push({
          event: "page_view",
          screen_name: "legal_age_needed_alert",
          screen_class: mappingScreenNameAnalytics(window.location.pathname),
        });
        setIsOver16(false);
        setConfirmationAge(true);
        break;
      case CHECKAGE.mandatoryAgeNeededNoOver16:
        setIsOver16(false);
        setConfirmationAge(true);
        break;
      default:
        callback && callback();
        break;
    }
  };
  const logoutClick = () => {
    setLogged(false);
    setSession({} as RaaSSession);
    setUserConnected({} as IUserData);
    removeItemStorage(SessionStorageItems.RAAS_USER);
    removeItemStorage(SessionStorageItems.RAAS_USER_DETAIL);
    setStorage();
  };

  const handleShowIncidentModal = (e: any) => {
    setIncidentsRoute(e.detail.incidentsRoute);
    setShowIncidentModal(true);
  };

  const handleAcceptSilentCar = () => {
    setShowSilentCardModal(false);
    setShowAveTariff(true);
  };

  const handleOtherTicketSilentCar = () => {
    var newtickets = [...tariffTickets] as any;

    newtickets.forEach((element: any) => {
      element.toggled = false;
    });
    setTariffTickets(newtickets);
    setSelectedRateSilentCar(false);
    setShowSilentCardModal(false);
  };

  const loadTrainEvent = (e: any) => { };

  /**
   * obtenemos precios de las estaciones
   * @param obj Estaciones de origin y destinos
   */
  const getInformationStations = (body: any) => {
    //setInitialBody(obj)
    //setBodyLongMover(e.detail)}
    if (body?.destination?.invalid == false && body?.origin?.invalid == false) {
      getInformationStationsApi(
        body,
        (response: IStation) => {
          let aux = {
            ...response,
            idItem: body.idItem,
          };
          setCalendarDays(aux);
        },
        (err: any) => {
          openToast(
            "error",
            t("literals.errorTryAgainLater"),
            `${err?.status}`
          );
        },
        window.sessionStorage["raas-trip-mock"]
      );
    }
  };

  const getInformationStationsMonths = (body: any) => {
    //setCalendarDays(null)
    let bodyAux = null as any;
    //Solo cambiamos fecha
    const date = new Date(body.viewDate);
    bodyAux = {
      ...(initialBody as any),
      month: (date.getMonth() + 1 < 10 ? "0" : "") + (date.getMonth() + 1),
      year: date.getFullYear().toString(),
    };

    getInformationStationsApi(
      bodyAux,
      (response: IStation) => {
        let aux = {
          ...response,
          idItem: body.idItem,
        };
        setCalendarDays(aux);
        //setInitialBody(bodyAux)
      },
      (err: any) => {
        openToast("error", t("literals.errorTryAgainLater"), `${err?.status}`);
      },
      window.sessionStorage["raas-trip-mock"]
    );
  };
  //console.log("tariffTickets",tariffTickets)

  return (
    <div className="trip-selector-container">
      {returnStep === 1 ? (
        <PLoadingItinerary
          literals={JSON.stringify(loadingReturnTripLiterals(t))}
        ></PLoadingItinerary>
      ) : (
        <>
          {showSubHeader && (
            <div className="sub-header-container">
              <MSubheaderPlannerTrain
                variant="train"
                isOnlyTrain={true}
                hasReturn={returnStep === 0 ? "true" : "false"}
                plannigObject={planningObject}
                literals={plannerSubLiteralsData}
                onSearchNewPlanEvent={handleSubHeaderPlanner}
                onSwitchEmitValue={(ev: any) => {
                  setIsReturnTrip(ev.detail);
                }}
                initialBody={initialBody}
                calendarDays={calendarDays}
                onGetSelectedStationsEvent={(e) =>
                  getInformationStations(e.detail)
                }
                onChangeMonth={(e) => getInformationStationsMonths(e.detail)}
                onBodyStations={(e) => setInitialBody(e.detail)}
              ></MSubheaderPlannerTrain>
            </div>
          )}
          <div className="col trip-selector-content">
            <div className="row p-0 m-0">
              <div className="col-12 trip-title mb-24"></div>
            </div>
            <div className="planning_body">
              <div className="left-section">
                <div style={{ position: "sticky", top: "210px" }}>
                  {!showNoResults && detailsSelector.length > 0 && (
                    <div className="row selector-trips">
                      <div className="col mb-24">
                        <MPaginatorTrain
                          pageNumber={paginatorPage}
                          onClickRouteBoxItem={(e: any) => {
                            setIndexSelectedObject({ index: e?.detail?.index });
                            const isDefaultSelected = !e?.detail?.item;
                            _setElementSelected(isDefaultSelected, e);
                          }}
                          tripPlanList={filteredTrips}
                          onUpdateRoute={() => {
                            updateApiCall();
                          }}
                          literals={routeBoxLiterals}
                          variant={ItemType.LONGMOVER}
                          onLoadTrainEvent={(e) => loadTrainEvent(e)}
                        ></MPaginatorTrain>
                      </div>
                    </div>
                  )}
                </div>
              </div>
              {!showNoResults && detailsSelector.length > 0 && (
                <div className="right-section">
                  <div>
                    <MDetailRoute
                      scrollinside={true}
                      literals={detailLiterals}
                      detailPrice={detailPriceTotal}
                      showDetailInfo={!isTariffMissing}
                      showBuyButton={!isTariffMissing}
                      detailLiterals={detailLiteralsAtom}
                      detailData={detailsSelector}
                      tripSummary={tripSummaryData}
                      onSelectedRoute={(ev: CustomEvent) =>
                        handleSelectRoute(ev)
                      }
                      onDeleteLeg={askDeleteItem}
                      onChangeTarif={handleChangeTarif}
                      onHimIncidentsModal={(ev: CustomEvent) =>
                        handleShowIncidentModal(ev)
                      }
                      disableDetailBut={disableDetailButton}
                      isLongMover={true}
                      variant={ItemType.PLAN}
                    ></MDetailRoute>
                  </div>
                </div>
              )}
            </div>
            {/* SECCIÓN NO RESULTADOS (trips retorna array vacío) */}
            {showNoResults && !showNoResultsByDate && (
              <div className="row p-0 m-0 justify-content-center">
                <PWithoutResults literals={noResultLiterals} />
              </div>
            )}
            {/* SECCIÓN NO RESULTADOS EN LA FECHA PLANIFICADA (trips retorna viajes fuera de la fecha planificada) */}
            {showNoResults && showNoResultsByDate && (
              <div className="row p-0 m-0 justify-content-center">
                <PWithoutResults
                  literals={noResultDateTripLiterals}
                />
              </div>
            )}

            {/* {showNoResultsByDate  && (
              <div className="row p-0 m-0 justify-content-center">
                <PWithoutResults
                  literals={JSON.stringify(noResultDateTripLiterals)}
                />
              </div>
            )} */}
          </div>
          <div>
            <LegalFooter literals={footerLiterals} fixed></LegalFooter>
          </div>
        </>
      )}
      {/* modales */}
      <UiModalRight blockOverlay={true} open={showFiltersModal}>
        <FilterOptions
          onCloseModal={() => setShowFiltersModal(false)}
          onSendFilter={closeFilters}
          options={JSON.stringify(filtersOptions)}
        />
      </UiModalRight>

      {/* Modal tarifas que no sean AVE*/}
      <UiModal open={showTariff} onModalClosed={() => setShowTarif(false)}>
        <PstTariff
          literals={tariffLiterals}
          adress={tarifAdress}
          tickets={tariffTickets}
          bono={tarifBono}
          color={tariffTag.backgroundcolor}
          text={tariffTag.text}
          tag={tariffTag}
          filter={tariffFilters}
          onSendBonoSelected={handleBonoClick}
          onOpenComment={(ev: any) => {
            handleOpenComment(ev);
          }}
          onCloseModal={() => setShowTarif(false)}
          onSendVehicle={(ev: any) => handleSelectVehicle(ev, false)}
          onSendSelection={(ev: any) => handleSelectionVehicle(ev)}
        />
      </UiModal>

      {/* Modal tarifas AVE*/}

      <UiModal
        key={"tarifAveModal"}
        open={showAveTariff}
        onModalClosed={() => setShowAveTariff(false)}
      >
        <AveTariff
          key={"tarifAveModal"}
          literals={avetariffLiterals}
          adress={tarifAdress}
          tickets={tariffTickets}
          bono={true}
          color={tariffTag.backgroundcolor}
          text={tariffTag.text}
          tag={tariffTag}
          isLongMover={true}
          onSendBonoSelected={handleBonoClick}
          onOpenComment={(ev: any) => {
            handleOpenComment(ev);
          }}
          onCloseModal={() => setShowAveTariff(false)}
          onSendVehicle={(ev: any) => handleSelectVehicle(ev, true)}
          onSendTrainRequest={() => handleSendTrainRequest()}
          onIsSwitchActivated={() => setShowSilentCardModal(true)}
        />
      </UiModal>
      {/* Modal lista trenes vuelta */}
      <UiModal
        key={"trainListTarif"}
        open={showFromToTrainList}
        onModalClosed={() => setShowFromToTrainList(false)}
      >
        {trainModalTariffSelected.length > 0 ? (
          <AveTariff
            key={"trainListTarif"}
            literals={avetariffLiterals}
            isReturnTrainModal={true}
            fromToTickets={trainModalTariffSelected}
            onSendReturnSelected={(ev: CustomEvent) =>
              handleSelectTrainTarifSelected(ev)
            }
            onCloseModal={() => setShowFromToTrainList(false)}
          />
        ) : (
          <div className="row p-0 m-0 justify-content-center">
            <PWithoutResults
              onCloseModal={() => setShowFromToTrainList(false)}
              isModal={true}
              literals={noResultTrainArrival}
            />
          </div>
        )}
      </UiModal>

      <UiModal blockOverlay={true} open={isTrainRequested}>
        <ConsentTermsRegisterModal
          literals={fromToAlertModalLiterals}
          img="error"
          onConsentClickEvent={() => {
            setIsTrainRequested(false);
            setShowAveTariff(true);
          }}
        ></ConsentTermsRegisterModal>
      </UiModal>

      <UiModal blockOverlay={true} open={isTrainSelected}>
        <ConsentTermsRegisterModal
          literals={fromToAlertReturnModalLiterals}
          img="information"
          onConsentClickEvent={() => {
            setIsTrainSelected(false);
            setShowAveTariff(true);
          }}
        ></ConsentTermsRegisterModal>
      </UiModal>

      <UiModal blockOverlay={true} open={isTrainRequestedFromBuyButton}>
        <ConsentTermsRegisterModal
          literals={fromToAlertModalLiterals}
          img="error"
          onConsentClickEvent={() => {
            setIsTrainRequestedFromBuyButton(false);
          }}
        ></ConsentTermsRegisterModal>
      </UiModal>

      {/* <UiModal
      open={showDriverComment}
      onModalClosed={() => setShowDriverComment(false)}
      notUseShiftLogic={true}
    >
      <CommentsToDriver
        valuesComments={noteDriverComment}
        idDetailSelected={detailIndexSelected}
        literals={JSON.stringify(driverCommentLiterals)}
        name={"driverCommentsModal"}
        onCancelModal={() => setShowDriverComment(false)}
        onCloseModal={() => setShowDriverComment(false)}
        onTextAreaValue={() => { }}
        onSendDriverRequest={(ev: CustomEvent) => addCommentsToDriver(ev, 'comments')}
      />
    </UiModal>
    <UiModal open={showBabyChair} blockOverlay={true}>
      <CommentsToDriver
        literals={JSON.stringify(babyChairsLiterals)}
        name={"BabyModal"}
        onCloseModal={handleCloseBaby}
        onSendDriverRequest={(ev: CustomEvent) =>
          handleBabyCountRequest(ev, threemodals, twomodals)
        }
      />
    </UiModal> */}
      <UiModal open={showUploadDocument} blockOverlay={true}>
        <UploadDocuments
          literals={JSON.stringify(uploadDocumentLiterals)}
          onOkModal={() => handleUploadDocument()}
        />
      </UiModal>
      <UiModal
        open={showAccessToApp}
        onModalClosed={() => setShowAccessToApp(false)}
      >
        <AccessToApp
          literals={accessToAppLiterals}
          onCancelModal={() => setShowAccessToApp(false)}
          onOkModal={() => {
            checkCooltra();
            //setShowAccessToApp(false);
          }}
        />
      </UiModal>
      <UiModal
        open={showRefreshModal}
        onModalClosed={() => setShowAccessToApp(false)}
      >
        <RefreshTarifsModal
          literals={refreshTarifModalLiterals}
          onConfirmButtonEvent={() => {
            setShowRefreshModal(false);
          }}
        />
      </UiModal>
      <UiModal
        open={showLoginModal}
        blockOverlay={true}
        onModalClosed={() => setShowLoginModal(false)}
        notUseShiftLogic={true}
      >
        {getModalSlot(step)}
      </UiModal>
      <UiModal open={showDeleteItemModal} blockOverlay={true}>
        <DeletePlanification
          literals={deletePlanificationModalLiterals}
          onCancelModal={() => {
            setShowDeleteItemModal(false);
          }}
          onOkModal={() => handleDeleteItemFromTripDetail()}
        ></DeletePlanification>
      </UiModal>
      {/* Control age */}
      <UiModal open={showModalUnder16} blockOverlay={true}>
        <UsersUnder16
          literals={usersUnder16ModalLiterals}
          onConfirmButtonEvent={() => okModalUnder16()}
        />
      </UiModal>
      <UiModal open={confirmationAge} blockOverlay={true}>
        <AgeConfirmation
          literals={{
            title: tGlobal("age-confirmation.title"),
            description: tGlobal("age-confirmation.description"),
            buttonText: tGlobal("age-confirmation.buttonText"),
            confirmationButton: tGlobal("age-confirmation.confirmationButton"),
            secondaryButtonText: tGlobal(
              "age-confirmation.secondaryButtonText"
            ),
          }}
          confirmation={isOver16}
          onUnderstood={handleUnderstoodClick}
          onCloseModal={handleCloseModalClick}
        />
      </UiModal>
      <UiModal open={showIncidentModal} blockOverlay={true}>
        <IncidentsRoute
          incidentsRoute={incidentsRoute}
          onCloseModal={() => {
            setShowIncidentModal(false);
          }}
        />
      </UiModal>
      <UiModal open={showSilentCardModal} blockOverlay={true}>
        <SilentCarRules
          onAccepTicket={() => handleAcceptSilentCar()}
          onOtherTicket={() => handleOtherTicketSilentCar()}
          literals={silentCarLiterals}
        />
      </UiModal>
    </div>
  );
}
